import { createSlice } from "@reduxjs/toolkit";

import { fetchPetsJobsData } from "../thunks/petsjobThunks"; // Ensure correct import

interface PetsJobsListState {
  petsJobsList: any[];
  loading: boolean;
  error: string | null;
}

const initialState: PetsJobsListState = {
  petsJobsList: [],
  loading: false,
  error: null,
};

export const petsJobsSlice = createSlice({
  name: "petsJobs", // Consistent with the slice usage
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPetsJobsData.pending, (state) => { // Updated thunk name
        state.loading = true;
        state.error = null; // Reset error on new request
      })
      .addCase(fetchPetsJobsData.fulfilled, (state, action) => {
        state.petsJobsList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchPetsJobsData.rejected, (state, action) => {
        state.error = action.payload as string || "Something went wrong";
        state.loading = false;
      });
  },
});

export default petsJobsSlice.reducer;
